<template>
  <div id="app">
    <header>

      <input type="checkbox" class="openSidebarMenu" id="openSidebarMenu" ref="sideBarToggleCheckbox" v-model="checked"/>
      <label for="openSidebarMenu" class="sidebarIconToggle">
        <div class="spinner diagonal part-1"></div>
        <div class="spinner horizontal"></div>
        <div class="spinner diagonal part-2"></div>
      </label>
      <div class="section-contents">
        <router-link to="/"><div class="header-logo"></div></router-link>
        <nav class="gnb-menu" id="sidebarMenu">
          <div class="join">
            <h2>프랜차이즈 문의</h2>
            <span>1599-2757</span>
            <p>
              창업 및 문의사항이 있으시면<br />
              언제든지 전화주세요
            </p>
          </div>
          <ul class="sidebarMenuInner mr-3">
            <li @click="clickLink">
              <router-link to="/">THE BROWN</router-link>
            </li>
            <li @click="clickLink">
              <router-link to="/menu/brunch">MENU</router-link>
              <ol>
                <li @click="clickLink"><router-link to="/menu/brunch">Brunch & Food</router-link></li>
                <li @click="clickLink"><router-link to="/menu/coffee">Coffee & Drink</router-link></li>
                <li @click="clickLink"><router-link to="/menu/bakery">Bakery & Cake</router-link></li>
              </ol>
            </li>
            <li @click="clickLink">
              <router-link to="/store">STORE</router-link>
            </li>
            <li @click="clickLink">
              <router-link to="/community">COMMUNITY</router-link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
    <v-app>
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <router-view/>
    </v-app>
  </div>
</template>
<script>

export default {

  data() {
    return {
      checked: false
    }
  },
methods: {
  clickLink() {
    this.checked = false
  }


  },
}
</script>